import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { queryKeys } from "@/services/react-query.service/query-keys";
import { useQuery } from "@tanstack/react-query";

import { getIndicatorQueryDocument } from "./indicator.gql";

export interface UseGetIndicatorProps {
  id?: string;
  enabled?: boolean;
}

export const useGetIndicator = ({ id, enabled = true }: UseGetIndicatorProps) => {
  const queryResult = useQuery({
    queryKey: queryKeys.indicators.detail(id ?? ""),
    queryFn: async () => {
      if (!id) {
        throw new Error("Indicator ID is required");
      }
      const client = createOperationClient("getIndicator");
      return await client.request(getIndicatorQueryDocument, { input: { id: id ?? "" } });
    },
    enabled: !!id && enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return {
    queryResult,
    loading: queryResult.isLoading,
    indicator: queryResult.data?.indicator ?? null,
    error: queryResult.error,
  };
};
